import style from './Switch.css';

export default function Switch({ className = '', ...props }) {
  return (
    <label className={`${className} ${style.label}`}>
      <input type="checkbox" className={style.input} {...props} />
    </label>
  );
}
